import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ErrorModal from '../components/errorModal';
import Loading from '../components/loading';
import SettingsIcon from '@mui/icons-material/Settings';
import Divider from '@mui/material/Divider';
import styles from '../styles/UserHome.module.scss';
import API from '../services/api';
import store from 'store-js';
import { useTranslation } from 'react-i18next';
import { useCookieState } from 'ahooks';

export default function UserHome({ config }) {
    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });
    const pageSetting = config.userPage_setting;
    const { t } = useTranslation();
    const navigate = useNavigate();
    // const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [btnId, setBtnId] = useState(null);
    const [newOrderNum, setNewOrderNum] = useState(null);
    const [newProductsNum, setNewProductsNum] = useState(null);
    const [username, setUsername] = useState(null);
    const [shopname, setShopname] = useState(null);
    const [address, setAddress] = useState(null);
    const [errModalMsg, setErrModalMsg] = useState(null);
    const [consoleMsg, setConsoleMsg] = useState(null);
    const [transition, setTransition] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
        // const token = store.get('access_token');
        if (token) {
            setTransition(false);
            // setToken(token);

            if (store.get('username')) {
                setUsername(store.get('username'));
                setShopname(store.get('shopname'));
                setAddress(store.get('address'));
            }
        } else navigate('/');
    }, []);

    useEffect(() => {
        // if (pageSetting.userInfo.display) {
        // if (token && !store.get("merchant_id")) getUserInfo();
        // }
        getUserInfo();
    }, [token]);

    // useEffect(() => {
    //   if (username || shopname || address) {
    //     store.set("username", username);
    //     store.set("shopname", shopname);
    //     store.set("address", address);
    //   }
    // }, [username, shopname, address]);

    const handleBtnClick = (redirectTo, routerParam, id) => {
        setBtnId(id);
        setIsLoading(true);

        routerParam ? navigate(`${redirectTo}/${routerParam}`) : navigate(`${redirectTo}`);
    };

    const getUserInfo = () => {
        const api = new API(token);
        api.getMerchantInfo()
            .then((res) => {
                console.log(res);
                if (res && !res.hasOwnProperty('error')) {
                    // setNewOrderNum(res.payload.active_order);
                    // setNewProductsNum(res.payload.active_voucher);
                    setUsername(res.payload.username);
                    setShopname(Object.values(res.payload.stores)[0].name);
                    setAddress(Object.values(res.payload.stores)[0].address);
                    store.set('store_id', Object.keys(res.payload.stores)[0]);
                    let details = Object.values(res.payload.stores)[0];
                    store.set('merchant_id', details.code);
                } else {
                    if (res.error !== 'invalidToken') {
                        setErrModalMsg('serverErr');
                        setConsoleMsg(`${res.error.error_code}: ${res.error.error_message}`);
                    } else setErrModalMsg(t(`${config.scannerErr_setting.errMsg.invalidToken}`));
                }
            })
            .catch((err) => {
                console.log(err);
                // setErrModalMsg('networkErr');
            });
    };

    const logout = () => {
        const api = new API(token);
        api.userLogout().then(() => {
            store.clearAll();
            setToken(null);
            navigate('/');
        });
    };

    return (
        <div className="content noselect">
            <div className="logoBg">
                {/* {pageSetting.setting_btn.display && (
          <button
            className="textBtn"
            onClick={() => {
              setTransition(true);
              handleBtnClick(pageSetting.setting_btn.redirectTo);
            }}
            style={{
              position: "absolute",
              left: "15px",
              top: "15px",
              color: pageSetting.setting_btn.color,
            }}
          >
            <SettingsIcon />
          </button>
        )} */}
                <span className={styles.loggedInStore}>{t('home_logged_in_store', { shopname })}</span>
                {pageSetting.logout_btn && (
                    <button
                        className="textBtn right"
                        type="button"
                        style={{
                            color: pageSetting.logout_btn.color
                        }}
                        onClick={logout}
                    >
                        {t(`${pageSetting.logout_btn.label}`)}
                    </button>
                )}

                <img src={pageSetting.logo_src} alt="banner" className="merchantLogo" />
            </div>

            <div className="marginContent">
                {pageSetting.buttons.map((btn, i) => (
                    <button
                        key={i}
                        className={btn.bg_color !== '#ffffff' ? 'colorBtn' : 'whiteBtn'}
                        type="button"
                        onClick={() => handleBtnClick(btn.redirectTo, btn.routerParam, i)}
                    >
                        {isLoading && i === btnId ? (
                            <Loading
                                type="bubbles"
                                color={btn.bg_color !== '#ffffff' ? '#ffffff' : config.theme.color}
                                width={50}
                                height={50}
                            />
                        ) : (
                            <>
                                {t(`${btn.label}`)}
                                {btn.showBadge.showNumber && btn.routerParam === 'order' ? (
                                    <span className={newOrderNum > 0 ? styles.badgeNum : ''}>
                                        {newOrderNum > 0 && newOrderNum}
                                    </span>
                                ) : (
                                    btn.showBadge.showNumber &&
                                    btn.routerParam !== 'order' && (
                                        <span className={newProductsNum > 0 ? styles.badgeNum : ''}>
                                            {newProductsNum > 0 && newProductsNum}
                                        </span>
                                    )
                                )}
                            </>
                        )}
                    </button>
                ))}

                {pageSetting.setting_btn.showBtn && (
                    <button
                        className="whiteBtn"
                        type="button"
                        onClick={() => {
                            setTransition(true);
                            handleBtnClick(pageSetting.setting_btn.redirectTo);
                        }}
                    >
                        {`${t(pageSetting.setting_btn.label)}`}
                    </button>
                )}

                {pageSetting.userInfo.display && (
                    <div className={styles.bottom}>
                        <Divider style={{ marginBottom: '20px' }} />
                        {pageSetting.userInfo.fields?.map((item, i) => (
                            <p key={i} className={styles.userInfo}>
                                {t(`${item.label}`)}
                                <span>
                                    {item.name === 'username'
                                        ? username
                                        : item.name === 'shopname'
                                        ? shopname
                                        : address}
                                </span>
                            </p>
                        ))}
                    </div>
                )}
            </div>

            <ErrorModal
                openModal={errModalMsg || consoleMsg ? true : false}
                errorMsg={errModalMsg}
                consoleMsg={consoleMsg}
                handleCloseModal={() => {
                    setErrModalMsg(null);
                    setConsoleMsg(null);
                }}
                config={config}
            />
            {transition && <Loading />}
        </div>
    );
}
